"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var common_hooks_1 = require("@l2p/common-hooks");
var DepositFailedDefault_1 = __importDefault(require("./DepositFailedDefault"));
var DepositFailedModal = function (props) {
    (0, common_hooks_1.useDisablePullToRefresh)();
    (0, common_hooks_1.useFixIosKeyboardScrollBug)();
    return react_1.default.createElement(DepositFailedDefault_1.default, __assign({}, props));
};
exports.default = DepositFailedModal;
